import { render } from "./LeeSwitch.vue?vue&type=template&id=ef310eb0"
import script from "./LeeSwitch.vue?vue&type=script&lang=js"
export * from "./LeeSwitch.vue?vue&type=script&lang=js"

import "./LeeSwitch.vue?vue&type=style&index=0&id=ef310eb0&lang=css"

import exportComponent from "F:\\leeao\\leeplus_docs_code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__